webpackJsonp([151129064198652],{

/***/ 930:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ClientRdvmInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"clientId","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"contactIds","type":{"enumValues":null,"fields":null,"kind":"LIST","name":null,"ofType":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"isPreferred","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"notes","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"rdvmId","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-client-rdvm-input-78dabf2dd36783a2ad92.js